import { useState, useEffect, useRef, createElement, forwardRef } from "react";
import Icon from '../colorful-icon';
import Button from '../colorful-button';
import classNames from "classnames";
import './index.scss';
const prefixCls = `au-searchbar`;
const ColorfulSearchbar = forwardRef(({ defaultValue, placeholder = '搜索', allowClear = true, inputStyle = {
    backgroundColor: '',
    padding: 9,
}, inputFont = {
    color: '',
    fontSize: 16,
    textAlign: '',
}, icon = createElement(Icon, { icon: "icon-search" }), iconPosition = 'left', iconBackground, barBackground, ...otherProps }, ref) => {
    const _otherProps = otherProps || {};
    const [inputValue, setInputValue] = useState(defaultValue);
    const [showClear, setShowClear] = useState(allowClear);
    const [hasFocus, setHasFocus] = useState(false);
    const inputRef = useRef(null);
    const classString = classNames(prefixCls, `searchbar-${iconPosition}`, {
        [`${prefixCls}-active`]: hasFocus,
    });
    const barStyles = {};
    const inputStyles = {};
    const iconStyles = {};
    if (barBackground) {
        barStyles.backgroundColor = barBackground;
    }
    if (iconBackground) {
        iconStyles.backgroundColor = iconBackground;
    }
    if (inputStyle.padding) {
        inputStyles.padding = `${inputStyle.padding}px`;
    }
    if (inputStyle.backgroundColor) {
        inputStyles.backgroundColor = inputStyle.backgroundColor;
    }
    if (inputFont.textAlign) {
        inputStyles.textAlign = inputFont.textAlign;
    }
    if (inputFont.color) {
        inputStyles.color = inputFont.color;
    }
    if (inputFont.fontSize) {
        inputStyles.fontSize = `${inputFont.fontSize}px`;
    }
    useEffect(() => {
        if (allowClear) {
            setShowClear(true);
        }
        else {
            setShowClear(false);
        }
    }, [allowClear]);
    useEffect(() => {
        if (defaultValue?.length > 0) {
            setInputValue(defaultValue);
            allowClear && setShowClear(true);
        }
        else {
            setShowClear(false);
        }
    }, [allowClear, defaultValue]);
    const handleChange = (e) => {
        const { value } = e.target;
        setInputValue(value);
        if (value) {
            allowClear && setShowClear(true);
        }
        else {
            setShowClear(false);
        }
        if (_otherProps.onChange) {
            _otherProps.onChange(e);
        }
    };
    const handleRemove = (e) => {
        setInputValue('');
        setShowClear(false);
    };
    const handleFocus = (e) => {
        allowClear && setShowClear(true);
        setHasFocus(true);
        _otherProps.onFocus?.(e);
    };
    const handleBlur = (e) => {
        setHasFocus(false);
    };
    const handleKeydown = (e) => {
        if (e.code === 'Enter' || e.keyCode === 13) {
            _otherProps.onSearch?.(inputValue);
        }
    };
    const iconView = (createElement("div", { className: "inner-icon", style: iconStyles }, icon));
    const input = (createElement("div", { className: 'inner-content' },
        createElement("input", { ref: ref || inputRef, className: 'inner-input', value: inputValue, placeholder: placeholder || '输入文本', onFocus: handleFocus, onBlur: handleBlur, onChange: handleChange, onKeyDown: handleKeydown, style: inputStyles }),
        showClear && createElement("i", { className: "icon-times-circle", onClick: handleRemove })));
    return (createElement("div", { className: classString, style: barStyles, ..._otherProps },
        icon && iconPosition === 'left' && iconView,
        input,
        icon && iconPosition === 'right' && iconView,
        _otherProps.allowCancel && createElement(Button, { link: true, onClick: handleRemove }, "\u53D6\u6D88")));
});
ColorfulSearchbar.displayName = 'ColorfulSearchbar';
export default ColorfulSearchbar;
